import React from 'react';
import MovieList from './componentes/MovieList';
import './App.css';

function App() {
return (
  <MovieList />
  );
}

export default App;
